import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { timestamp_ms } from '@shared/utils/utils_time';
import { useMemo } from 'react';
import { use_slice_user, use_slice_workspace } from '../store/use_slices';

export function HOOK_WORKSPACE__get_list_sorted() {
  const { user_id } = use_slice_user(['user_id']);
  const { workspaces_map, all_workspaces_users_map } = use_slice_workspace(['workspaces_map', 'all_workspaces_users_map']);

  const out = useMemo(() => {
    return Array.from(workspaces_map.values()).sort(sort_workspaces);
  }, [workspaces_map, all_workspaces_users_map, user_id]);

  /*
   * METHODS
   */

  function sort_workspaces(a: DTO__workspace, b: DTO__workspace) {
    let workspace_a_users_map = all_workspaces_users_map.get_or_create_map(a._id);
    let workspace_b_users_map = all_workspaces_users_map.get_or_create_map(b._id);

    let created_at = timestamp_ms();

    let user_in_workspace_a = workspace_a_users_map.get_value_or_default(user_id, DTO__workspace_user.CREATE_STUB({ created_at }));
    let user_in_workspace_b = workspace_b_users_map.get_value_or_default(user_id, DTO__workspace_user.CREATE_STUB({ created_at }));

    return user_in_workspace_a.created_at - user_in_workspace_b.created_at;
  }

  return out;
}
